import { Injectable } from '@angular/core';

/**
 * Acceso tipado y seguro a localStorage (serializa/parsea JSON y nunca lanza).
 * Punto único para tokens, sesión y preferencias.
 */
@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  get<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  }

  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* almacenamiento lleno o no disponible: ignorar de forma segura */
    }
  }

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      /* no-op */
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch {
      /* no-op */
    }
  }
}
